import {
  Avatar,
  Card,
  CrossIcon,
  Heading,
  IconButton,
  Label,
  Menu,
  MoreIcon,
  Pane,
  Paragraph,
  Popover,
  SideSheet,
  Tab,
  Table,
  Tablist,
  TextInputField,
  toaster,
} from "evergreen-ui";
import React, { useState } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import Button from "../Button";
import CashHistory from "../CashHistory";
import PackageSelector from "../PackageSelector";
import UserNetwork from "../UserNetwork";
import UserSelector from "../UserSelector";
import styled from "styled-components";
import { gql, useMutation, useQuery } from "@apollo/client";
import { UPDATE_USER_PROFILE } from "src/Mutations/Users.share";
import CashPending from "../CashPending";
import RestockHistory from "../RestockHistory";
import Shipments from "../Shipments";
import useInput from "src/Hooks/useInput";
import DownlineRestocks from "../DownlineRestocks";
import RBRecords from "../RBRecords";

const ButtonWrapper = styled.div`
  padding: 1rem 0px;
`;

const CHECK_USERNAME = gql`
  query checkUsername($username: String!) {
    users(where: { username: { _ilike: $username } }) {
      id
    }
  }
`;
const CHECK_IC_NO = gql`
  query checkUsername($ic: String!) {
    users(where: { ic_no: { _ilike: $ic } }) {
      id
    }
  }
`;
interface IProps extends RouteComponentProps<any> {
  id: any;
  name: any;
  created_at: any;
  username: any;
  avatar: any;
  phone: any;
  ic_no: any;
  downlines: any;
  userRank: any;
  userUpline: any;
  email: string;
  showAgent: boolean;
  displayName: any;
  showColumn: any;
  address: any;
  refetch: any;
  banks: any;
}
const AdminAgentRow: React.SFC<IProps> = ({
  displayName,
  ic_no,
  id,
  avatar,
  name,
  refetch,
  username,
  created_at,
  address,
  showColumn,
  email,
  match,
  userUpline,
  userRank,
  showAgent,
  history,
  phone,
  banks,
}) => {
  const [selectedTab, setSelectedTab] = useState("agent");
  const [showDetails, setShowDetails] = useState(showAgent);

  const [isLoading, setIsLoading] = useState(false);
  const icChange = useInput(ic_no || "");
  const phoneChange = useInput(phone);
  const usernameChange = useInput(username || "");
  const [selectedRank, setSelectedrank] = useState(userRank);
  const [uplineId, setUplineId] = useState(userUpline ? userUpline.id : null);
  const [updateUser] = useMutation(UPDATE_USER_PROFILE);
  const toggleShowDetails = () => {
    setShowDetails(!showDetails);
  };

  const {
    data: usernameData,
    loading: usernameLoading,
    error: usernameError,
  } = useQuery(CHECK_USERNAME, {
    variables: {
      username: usernameChange.value,
    },
  });
  const { data: icData, loading: icLoading, error: icError } = useQuery(
    CHECK_IC_NO,
    {
      variables: {
        ic: icChange.value,
      },
    }
  );

  const onDownlineClick = (username) => {
    history.push("/admin/agents/" + username);
  };

  const saveAgentChanges = (e) => {
    e.preventDefault();
    setIsLoading(true);
    updateUser({
      variables: {
        id,
        object: {
          phone: phoneChange.value,
          ic_no: icChange.value,
          username: usernameChange.value,
          upline: uplineId,
          current_rank: selectedRank.id,
        },
      },
    })
      .then(() => {
        toaster.success("Changes saved!");
        refetch().then(() => {
          setIsLoading(false);
        });
      })
      .catch((e) => {
        setIsLoading(false);
        toaster.danger(e.message);
      });
  };

  const changeRank = (rank) => {
    setSelectedrank(rank);
  };

  return (
    <Table.Row>
      <Table.TextCell>{displayName}</Table.TextCell>
      <Table.TextCell>{username}</Table.TextCell>
      <Table.TextCell>{ic_no || "No IC yet."}</Table.TextCell>
      <Table.TextCell>{created_at}</Table.TextCell>
      <Table.TextCell>{showColumn}</Table.TextCell>
      <Table.TextCell>
        {userRank.chinese_name || "没有身份"} | {userRank.name || "NO RANK"}
      </Table.TextCell>
      <Table.Cell>
        <Popover
          content={({ close }) => (
            <Menu>
              <Menu.Group title="Options">
                <Menu.Item
                  onSelect={() => {
                    history.push("/admin/agents/" + username);
                    toggleShowDetails();
                  }}
                >
                  View / Edit
                </Menu.Item>
                {/* <Menu.Item
                  onSelect={() => {
                    toaster.warning("Coming soon!");
                    close();
                  }}
                  intent="danger"
                >
                  Disable
                </Menu.Item> */}
              </Menu.Group>
            </Menu>
          )}
        >
          <IconButton appearance="minimal" height={24} icon={MoreIcon} />
        </Popover>
      </Table.Cell>
      <SideSheet
        preventBodyScrolling
        containerProps={{
          display: "flex",
          flex: "1",
          flexDirection: "column",
          maxWidth: "100vw",
        }}
        isShown={showDetails}
      >
        <Pane
          position="sticky"
          top="0"
          zIndex={1}
          flexShrink={0}
          elevation={0}
          background="tint1"
        >
          <Pane padding={16}>
            <Pane
              flexDirection="row"
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Pane>
                <Label>{created_at}</Label>
                <Pane
                  marginTop=".3rem"
                  display="flex"
                  flexDirection="row"
                  alignItems="center"
                >
                  <Avatar
                    marginRight=".3rem"
                    src={avatar}
                    name={name}
                    size={40}
                  />
                  <Pane display="flex" flexDirection="column">
                    <Heading>
                      {name} ({username})
                    </Heading>
                    <Paragraph>
                      {userRank.chinese_name
                        ? userRank.chinese_name + " | " + userRank.name
                        : userRank}{" "}
                      {userUpline.name
                        ? `| Upline: ${userUpline.name} (${userUpline.username})`
                        : " | No upline"}
                    </Paragraph>
                  </Pane>
                </Pane>
              </Pane>
              <IconButton icon={CrossIcon} onClick={toggleShowDetails} />
            </Pane>
          </Pane>
          <Pane>
            <Tablist>
              <Tab
                isSelected={selectedTab === "agent"}
                onSelect={() => {
                  setSelectedTab("agent");
                }}
              >
                Agent Details
              </Tab>
              <Tab
                isSelected={selectedTab === "address"}
                onSelect={() => {
                  setSelectedTab("address");
                }}
              >
                Address Book
              </Tab>
              <Tab
                isSelected={selectedTab === "bank"}
                onSelect={() => {
                  setSelectedTab("bank");
                }}
              >
                Bank
              </Tab>
              <Tab
                isSelected={selectedTab === "network"}
                onSelect={() => {
                  setSelectedTab("network");
                }}
              >
                Network
              </Tab>
              <Tab
                isSelected={selectedTab === "withdrawal"}
                onSelect={() => {
                  setSelectedTab("withdrawal");
                }}
              >
                Cash Pending
              </Tab>
              <Tab
                isSelected={selectedTab === "cash"}
                onSelect={() => {
                  setSelectedTab("cash");
                }}
              >
                Cash History
              </Tab>
              <Tab
                isSelected={selectedTab === "stock"}
                onSelect={() => {
                  setSelectedTab("stock");
                }}
              >
                Stock History
              </Tab>

              <Tab
                isSelected={selectedTab === "restock"}
                onSelect={() => {
                  setSelectedTab("restock");
                }}
              >
                Restock History
              </Tab>
              <Tab
                isSelected={selectedTab === "downlineRestocks"}
                onSelect={() => {
                  setSelectedTab("downlineRestocks");
                }}
              >
                Downline Restock History
              </Tab>
              <Tab
                isSelected={selectedTab === "shipment"}
                onSelect={() => {
                  setSelectedTab("shipment");
                }}
              >
                Shipments
              </Tab>
              <Tab
                isSelected={selectedTab === "rb"}
                onSelect={() => {
                  setSelectedTab("rb");
                }}
              >
                RB
              </Tab>
              {/* <Tab
                isSelected={selectedTab === "drb"}
                onSelect={() => {
                  setSelectedTab("drb");
                }}
              >
                DRB
              </Tab> */}
            </Tablist>
          </Pane>
        </Pane>
        {selectedTab === "agent" && (
          <Card backgroundColor="white" padding=".8rem">
            <Heading>Agent Details</Heading>
            <p className=" mt-4 font-semibold text-sm text-gray-600">
              E-mail: <span className=" font-normal">{email}</span>
            </p>
            <TextInputField
              placeholder="username"
              {...usernameChange}
              label="Username."
              validationMessage={
                username !== usernameChange.value &&
                usernameData?.users?.length > 0 &&
                "The username is taken!"
              }
            />
            <TextInputField
              placeholder="XXXXXX08XXXX"
              {...icChange}
              label="IC No."
              validationMessage={
                ic_no !== icChange.value &&
                icData?.users?.length > 0 &&
                "The IC is in use."
              }
            />
            <TextInputField
              placeholder="01XXXXXXXX"
              {...phoneChange}
              label="Phone"
              validationMessage={
                phoneChange.value === "" && "Please fill in a phone number!"
              }
            />
            <UserSelector
              label="Select upline"
              currentValue={
                userUpline.id
                  ? `${userUpline.name} (${userUpline.username})`
                  : ""
              }
              onSelect={(id) => {
                setUplineId(id);
              }}
            />
            <PackageSelector
              base={true}
              onSelect={changeRank}
              label="Change Agent Rank"
            />
            <ButtonWrapper>
              <Button
                label="Save"
                loading={isLoading}
                onClick={saveAgentChanges}
                disabled={
                  usernameLoading ||
                  icLoading ||
                  (username !== usernameChange.value &&
                    usernameData?.users?.length > 0) ||
                  (ic_no !== icChange.value && icData?.users?.length > 0)
                }
              />
              {usernameError?.message}
              {icError?.message}
            </ButtonWrapper>
          </Card>
        )}
        {selectedTab === "bank" && (
          <div className=" bg-gray-50 p-3 flex flex-col flex-1">
            {banks?.length > 0 ? (
              banks.map((bank, index) => (
                <div
                  key={index}
                  className=" p-2 bg-white border border-gray-100 rounded-sm"
                >
                  <p className=" text-base">Bank name: {bank.bank_name}</p>
                  <p className=" text-base">
                    Bank account holder: {bank.bank_acc_name}
                  </p>
                  <p className=" text-base">
                    Bank account no: {bank.bank_acc_no}
                  </p>
                </div>
              ))
            ) : (
              <div className=" flex flex-1 items-center justify-center p-4">
                No information yet.
              </div>
            )}
          </div>
        )}
        {selectedTab === "address" && (
          <Pane flex={1}>
            <div className=" w-full bg-gray-50 p-2 flex flex-1">
              <div className=" w-full p-2">
                {address.map((a) => {
                  return (
                    <div className=" w-full rounded overflow-hidden mb-2 border border-solid border-gray-50">
                      <div className=" w-full p-2 bg-gray-100">{a.name}</div>
                      <div className=" w-full bg-white p-2 flex flex-col">
                        Address: {a.line} <br />
                        City: {a.city}
                        <br />
                        State: {a.state}
                        <br />
                        Postcode: {a.postcode} <br />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </Pane>
        )}
        {selectedTab === "cash" && (
          <Pane flex={1}>
            <Card
              backgroundColor="white"
              paddingBottom=".4rem"
              marginBottom="20vh"
            >
              <CashHistory id={id} />
            </Card>
          </Pane>
        )}

        {selectedTab === "network" && (
          <Pane flex={1} padding="1rem">
            <Card
              backgroundColor="white"
              paddingBottom=".4rem"
              marginBottom="20vh"
            >
              <UserNetwork
                onClick={onDownlineClick}
                expand={true}
                username={username}
              />
            </Card>
          </Pane>
        )}
        {selectedTab === "withdrawal" && <CashPending id={id} />}
        {selectedTab === "restock" && <RestockHistory id={id} />}
        {selectedTab === "downlineRestocks" && <DownlineRestocks id={id} />}
        {selectedTab === "shipment" && <Shipments id={id} />}
        {selectedTab === "rb" && <RBRecords id={id} />}
      </SideSheet>
    </Table.Row>
  );
};

export default withRouter(AdminAgentRow);
